import { useState, useEffect, useCallback } from 'react'
import { ApiResponse } from '../services/api'

export const useApiData = <T> (
  fetchFunction: () => Promise<ApiResponse<T>>,
  initialData: T | null = null
) => {
  const [apiState, setApiState] = useState<ApiResponse<T>>({
    data: initialData,
    error: null,
    loading: true,
  })

  const executeFetch = useCallback(async (): Promise<void> => {
    try {
      setApiState(prev => ({ ...prev, loading: true, error: null }))
      const result = await fetchFunction()
      setApiState(result)
    } catch (error) {
      setApiState({
        data: null,
        error: error instanceof Error ? error.message : 'Unknown error',
        loading: false
      })
    }
  }, [fetchFunction])

  useEffect(() => {
    executeFetch()
  }, [executeFetch])

  const refetch = useCallback(async (): Promise<void> => {
    await executeFetch()
  }, [executeFetch])

  return { ...apiState, refetch }
}